// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"MassMedia__Wrapper_2SxqC","Cards":"MassMedia__Cards_36Xnk grid"};